module.exports = __webpack_public_path__ + "img/course.35b8d194.png";